import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const updateResellerGroupIds = async (identity, context = {}) => {
  try {
    const updateResellerGroupIdsFn = httpsCallable(functions, 'updateResellerGroupIdsV2');
    const result = await updateResellerGroupIdsFn({
      resellerId: identity?.resellerId,
      // Compatibilidad para perfiles legacy-only. El backend contrasta este
      // email con Auth; nunca lo usa como identidad canónica.
      email: identity?.email,
      ...context,
      requestedApp: context.requestedApp || 'dealership_web',
    });
    return result.data;
  } catch (error) {
    console.error('Error actualizando groupIds:', error);
    notifyPermissionDenied(error);
    return { success: 'no', message: error.message };
  }
};
